<template>
  <div>
    <label>Деятельность</label>
    <select
      class="form-control mb-2"
      v-if="!loading"
      v-model="item"
      @change="$emit('input', item)"
    >
      <option value="0">Выберите</option>
      <option v-for="(i, key) in items" :key="key" :value="i.id">
        {{ i.body_uz }}/ {{ i.body_ru }}
      </option>
    </select>

    <select
      v-else
      class="form-control mb-2"
      placeholder="Загрузка справочника..."
      disabled="disabled"
    >
      <option>Ожидайте...</option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: null,
    },
    partner: {
      default: function () {
        return {};
      },
    },
  },
  async created() {
    await this.getItems();
    if (this.value) {
      this.item = this.value;
    }
  },
  data() {
    return {
      items: [],
      item: null,
      loading: true,
    };
  },
  methods: {
    async getItems() {
      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.items = await this.$http
        .get(
          `${partner["endpoint_url"]}clients/clients/questionnaire/activity-areas`,
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          return null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>